import { PlanLimitConfigs, BillingCycleConfig } from "../common.ts";

export const LOOM_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const LOOM_DEFAULT_UNIT_COUNT = 100;

export const LOOM_MIN_ENTERPRISE_USER_COUNT = Infinity;

export const loomOfferingSkus = {
    free: "loom-free-sku",
    business: "loom-business-sku",
    businessPlusAi: "loom-business-ai-sku",
    enterprise: "loom-enterprise-sku"
} as const;

export const loomOfferingSkusArray = Object.values(loomOfferingSkus);

export const loomPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: loomOfferingSkus.free,
        recommendationLimit: Infinity,
        signupLimit: 50_000
    },
    {
        planName: "Business",
        offeringSku: loomOfferingSkus.business,
        recommendationLimit: Infinity,
        signupLimit: 50_000
    },
    {
        planName: "Business + AI",
        offeringSku: loomOfferingSkus.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50_000
    },
    {
        planName: "Enterprise",
        offeringSku: loomOfferingSkus.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50_000
    }
];

export const loomBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
